import { inject } from '@angular/core';
import { type Observable, tap } from 'rxjs';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { BillingQuoteRequestService } from './generated/billing-quote-request/billing-quote-request.service';
import type { QuoteRequestStatusResponseV1 } from './generated/types';

interface QuoteRequestStatusState {
  /** Landing requests without a quote; `null` = not answered yet (the label shows no
   *  count). A failed fetch keeps it as it was: the interceptor toasts it. */
  unattended: number | null;
}

/**
 * Feeds the «Solicitudes (n)» label of the admin menu (M-bill-19). Same shape as
 * `LegalAcceptanceStatusStore` (store-conventions §5.3): read when the admin shell mounts
 * and again after whatever attends or frees a request.
 */
export const QuoteRequestStatusStore = signalStore(
  withState<QuoteRequestStatusState>({ unattended: null }),
  withMethods((store, api = inject(BillingQuoteRequestService)) => ({
    fetchStatus(): Observable<QuoteRequestStatusResponseV1> {
      return api.billingV1QuoteRequestsStatusRetrieve().pipe(
        tap((res) => {
          patchState(store, { unattended: res.quote_request_status.unattended });
        }),
      );
    },
  })),
);
